export const translations = {
  ITA: {
    // Auth
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    name: "Nome",
    logout: "Esci",
    
    // Language selection
    selectLanguage: "Seleziona la lingua",
    languageDescription: "Scegli la lingua predefinita per i tuoi contratti",
    continue: "Continua",
    
    // Owner profile
    ownerProfile: "Profilo Proprietario",
    completeProfile: "Completa il tuo profilo",
    personalData: "Dati Personali",
    fullName: "Nome e Cognome",
    birthPlace: "Luogo di Nascita",
    birthDate: "Data di Nascita",
    residence: "Indirizzo di Residenza",
    taxCode: "Codice Fiscale",
    
    // Property
    propertyData: "Dati Immobile",
    propertyCity: "Comune",
    propertyProvince: "Provincia",
    propertyAddress: "Indirizzo",
    propertyNumber: "Numero Civico",
    cadastralSheet: "Foglio Catastale",
    cadastralParcel: "Particella",
    cadastralSub: "Subalterno",
    cinCode: "Codice CIN",
    maxOccupants: "Massimo Occupanti",
    petsAllowed: "Animali Ammessi",
    
    // Dashboard
    dashboard: "Dashboard",
    contracts: "Contratti",
    newContract: "Nuovo Contratto",
    noContracts: "Nessun contratto trovato",
    createFirst: "Crea il tuo primo contratto",
    
    // Contract
    contractDetails: "Dettagli Contratto",
    nights: "Notti",
    checkIn: "Check-in",
    checkOut: "Check-out",
    totalRent: "Canone Totale",
    deposit: "Caparra",
    balance: "Saldo",
    touristTax: "Tassa di Soggiorno",
    paymentMethod: "Metodo di Pagamento",
    securityDeposit: "Deposito Cauzionale",
    placeDate: "Luogo e Data",
    
    // Guest
    guestData: "Dati Ospite",
    documentNumber: "Documento (Tipo e Numero)",
    signature: "Firma",
    signContract: "Firma Contratto",
    clearSignature: "Cancella Firma",
    submitSignature: "Conferma Firma",
    privacyConsent: 'PRIVACY & DATI: La piattaforma "Locazione Turistica" non archivia, conserva, né tratta i dati personali inseriti nel presente contratto. Il software agisce esclusivamente come strumento tecnico per la generazione del documento in tempo reale. Il Titolare del Trattamento è l\'Host, il quale è l\'unico responsabile della conservazione e della protezione dei dati sottoscritti, in conformità al GDPR. Firmando, l\'ospite dichiara di accettare.',
    privacyAccept: "Accetto l'informativa privacy",
    
    // Status
    pending: "In Attesa",
    completed: "Completato",
    
    // Actions
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    download: "Scarica",
    share: "Condividi Link",
    copy: "Copia",
    copied: "Copiato!",
    
    // Messages
    profileSaved: "Profilo salvato",
    contractCreated: "Contratto creato",
    contractSigned: "Contratto firmato con successo",
    linkCopied: "Link copiato negli appunti",
    
    // Contract template labels
    landlord: "IL LOCATORE",
    tenant: "IL CONDUTTORE (OSPITE)",
    propertyObject: "OGGETTO DELLA LOCAZIONE",
    stayDuration: "DURATA DEL SOGGIORNO",
    rentPayment: "CORRISPETTIVO E MODALITA DI PAGAMENTO",
    houseRules: "OBBLIGHI E REGOLE DELLA CASA",
    landlordSignature: "FIRMA DEL LOCATORE",
    tenantSignature: "FIRMA DEL CONDUTTORE",
  },
  ENG: {
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Name",
    logout: "Logout",
    selectLanguage: "Select Language",
    languageDescription: "Choose the default language for your contracts",
    continue: "Continue",
    ownerProfile: "Owner Profile",
    completeProfile: "Complete your profile",
    personalData: "Personal Data",
    fullName: "Full Name",
    birthPlace: "Place of Birth",
    birthDate: "Date of Birth",
    residence: "Residence Address",
    taxCode: "Tax Code",
    propertyData: "Property Data",
    propertyCity: "City",
    propertyProvince: "Province",
    propertyAddress: "Address",
    propertyNumber: "Street Number",
    cadastralSheet: "Cadastral Sheet",
    cadastralParcel: "Parcel",
    cadastralSub: "Sub",
    cinCode: "CIN Code",
    maxOccupants: "Max Occupants",
    petsAllowed: "Pets Allowed",
    dashboard: "Dashboard",
    contracts: "Contracts",
    newContract: "New Contract",
    noContracts: "No contracts found",
    createFirst: "Create your first contract",
    contractDetails: "Contract Details",
    nights: "Nights",
    checkIn: "Check-in",
    checkOut: "Check-out",
    totalRent: "Total Rent",
    deposit: "Deposit",
    balance: "Balance",
    touristTax: "Tourist Tax",
    paymentMethod: "Payment Method",
    securityDeposit: "Security Deposit",
    placeDate: "Place and Date",
    guestData: "Guest Data",
    documentNumber: "Document (Type and Number)",
    signature: "Signature",
    signContract: "Sign Contract",
    clearSignature: "Clear Signature",
    submitSignature: "Submit Signature",
    privacyConsent: 'PRIVACY & DATA: The "Locazione Turistica" platform does not store, retain, or process the personal data entered in this contract. The software acts exclusively as a technical tool for generating the document in real time. The Data Controller is the Host, who is solely responsible for the storage and protection of the signed data, in compliance with the GDPR. By signing, the guest declares acceptance.',
    privacyAccept: "I accept the privacy policy",
    pending: "Pending",
    completed: "Completed",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    download: "Download",
    share: "Share Link",
    copy: "Copy",
    copied: "Copied!",
    profileSaved: "Profile saved",
    contractCreated: "Contract created",
    contractSigned: "Contract signed successfully",
    linkCopied: "Link copied to clipboard",
    landlord: "THE LANDLORD",
    tenant: "THE TENANT (GUEST)",
    propertyObject: "OBJECT OF THE LEASE",
    stayDuration: "DURATION OF THE STAY",
    rentPayment: "RENT AND PAYMENT METHODS",
    houseRules: "HOUSE RULES AND OBLIGATIONS",
    landlordSignature: "LANDLORD'S SIGNATURE",
    tenantSignature: "TENANT'S SIGNATURE",
  },
  FRA: {
    login: "Connexion",
    register: "S'inscrire",
    email: "Email",
    password: "Mot de passe",
    name: "Nom",
    logout: "Deconnexion",
    selectLanguage: "Selectionnez la langue",
    languageDescription: "Choisissez la langue par defaut pour vos contrats",
    continue: "Continuer",
    ownerProfile: "Profil Proprietaire",
    completeProfile: "Completez votre profil",
    personalData: "Donnees Personnelles",
    fullName: "Nom et Prenom",
    birthPlace: "Lieu de Naissance",
    birthDate: "Date de Naissance",
    residence: "Adresse de Residence",
    taxCode: "Code Fiscal",
    propertyData: "Donnees du Bien",
    propertyCity: "Ville",
    propertyProvince: "Province",
    propertyAddress: "Adresse",
    propertyNumber: "Numero",
    cadastralSheet: "Feuille Cadastrale",
    cadastralParcel: "Parcelle",
    cadastralSub: "Sous-parcelle",
    cinCode: "Code CIN",
    maxOccupants: "Occupants Maximum",
    petsAllowed: "Animaux Autorises",
    dashboard: "Tableau de Bord",
    contracts: "Contrats",
    newContract: "Nouveau Contrat",
    noContracts: "Aucun contrat trouve",
    createFirst: "Creez votre premier contrat",
    contractDetails: "Details du Contrat",
    nights: "Nuits",
    checkIn: "Arrivee",
    checkOut: "Depart",
    totalRent: "Loyer Total",
    deposit: "Acompte",
    balance: "Solde",
    touristTax: "Taxe de Sejour",
    paymentMethod: "Mode de Paiement",
    securityDeposit: "Depot de Garantie",
    placeDate: "Lieu et Date",
    guestData: "Donnees du Locataire",
    documentNumber: "Document (Type et Numero)",
    signature: "Signature",
    signContract: "Signer le Contrat",
    clearSignature: "Effacer la Signature",
    submitSignature: "Confirmer la Signature",
    privacyConsent: 'CONFIDENTIALITE & DONNEES : La plateforme "Locazione Turistica" ne stocke, ne conserve, ni ne traite les donnees personnelles saisies dans ce contrat. Le logiciel agit exclusivement comme un outil technique pour la generation du document en temps reel. Le Responsable du Traitement est l\'Hote, qui est seul responsable de la conservation et de la protection des donnees signees, conformement au RGPD. En signant, le locataire declare accepter.',
    privacyAccept: "J'accepte la politique de confidentialite",
    pending: "En Attente",
    completed: "Complete",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    download: "Telecharger",
    share: "Partager le Lien",
    copy: "Copier",
    copied: "Copie!",
    profileSaved: "Profil enregistre",
    contractCreated: "Contrat cree",
    contractSigned: "Contrat signe avec succes",
    linkCopied: "Lien copie dans le presse-papiers",
    landlord: "LE BAILLEUR",
    tenant: "LE LOCATAIRE",
    propertyObject: "OBJET DE LA LOCATION",
    stayDuration: "DUREE DU SEJOUR",
    rentPayment: "LOYER ET MODALITES DE PAIEMENT",
    houseRules: "REGLES DE LA MAISON",
    landlordSignature: "SIGNATURE DU BAILLEUR",
    tenantSignature: "SIGNATURE DU LOCATAIRE",
  },
  SPA: {
    login: "Iniciar sesion",
    register: "Registrarse",
    email: "Correo electronico",
    password: "Contrasena",
    name: "Nombre",
    logout: "Cerrar sesion",
    selectLanguage: "Seleccionar idioma",
    languageDescription: "Elige el idioma predeterminado para tus contratos",
    continue: "Continuar",
    ownerProfile: "Perfil del Propietario",
    completeProfile: "Completa tu perfil",
    personalData: "Datos Personales",
    fullName: "Nombre Completo",
    birthPlace: "Lugar de Nacimiento",
    birthDate: "Fecha de Nacimiento",
    residence: "Direccion de Residencia",
    taxCode: "Codigo Fiscal",
    propertyData: "Datos del Inmueble",
    propertyCity: "Ciudad",
    propertyProvince: "Provincia",
    propertyAddress: "Direccion",
    propertyNumber: "Numero",
    cadastralSheet: "Hoja Catastral",
    cadastralParcel: "Parcela",
    cadastralSub: "Subparcela",
    cinCode: "Codigo CIN",
    maxOccupants: "Maximo de Ocupantes",
    petsAllowed: "Mascotas Permitidas",
    dashboard: "Panel de Control",
    contracts: "Contratos",
    newContract: "Nuevo Contrato",
    noContracts: "No se encontraron contratos",
    createFirst: "Crea tu primer contrato",
    contractDetails: "Detalles del Contrato",
    nights: "Noches",
    checkIn: "Entrada",
    checkOut: "Salida",
    totalRent: "Alquiler Total",
    deposit: "Deposito",
    balance: "Saldo",
    touristTax: "Tasa Turistica",
    paymentMethod: "Metodo de Pago",
    securityDeposit: "Deposito de Seguridad",
    placeDate: "Lugar y Fecha",
    guestData: "Datos del Huesped",
    documentNumber: "Documento (Tipo y Numero)",
    signature: "Firma",
    signContract: "Firmar Contrato",
    clearSignature: "Borrar Firma",
    submitSignature: "Confirmar Firma",
    privacyConsent: 'PRIVACIDAD Y DATOS: La plataforma "Locazione Turistica" no almacena, conserva ni trata los datos personales introducidos en este contrato. El software actua exclusivamente como herramienta tecnica para la generacion del documento en tiempo real. El Responsable del Tratamiento es el Anfitrion, quien es el unico responsable de la conservacion y proteccion de los datos firmados, de conformidad con el RGPD. Al firmar, el huesped declara aceptar.',
    privacyAccept: "Acepto la politica de privacidad",
    pending: "Pendiente",
    completed: "Completado",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    download: "Descargar",
    share: "Compartir Enlace",
    copy: "Copiar",
    copied: "Copiado!",
    profileSaved: "Perfil guardado",
    contractCreated: "Contrato creado",
    contractSigned: "Contrato firmado con exito",
    linkCopied: "Enlace copiado al portapapeles",
    landlord: "EL ARRENDADOR",
    tenant: "EL ARRENDATARIO (HUESPED)",
    propertyObject: "OBJETO DEL ARRENDAMIENTO",
    stayDuration: "DURACION DE LA ESTANCIA",
    rentPayment: "RENTA Y FORMAS DE PAGO",
    houseRules: "NORMAS DE LA CASA",
    landlordSignature: "FIRMA DEL ARRENDADOR",
    tenantSignature: "FIRMA DEL ARRENDATARIO",
  },
  TED: {
    login: "Anmelden",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    logout: "Abmelden",
    selectLanguage: "Sprache wahlen",
    languageDescription: "Wahlen Sie die Standardsprache fur Ihre Vertrage",
    continue: "Weiter",
    ownerProfile: "Eigentumerprofil",
    completeProfile: "Vervollstandigen Sie Ihr Profil",
    personalData: "Personliche Daten",
    fullName: "Vollstandiger Name",
    birthPlace: "Geburtsort",
    birthDate: "Geburtsdatum",
    residence: "Wohnadresse",
    taxCode: "Steuernummer",
    propertyData: "Immobiliendaten",
    propertyCity: "Stadt",
    propertyProvince: "Provinz",
    propertyAddress: "Adresse",
    propertyNumber: "Hausnummer",
    cadastralSheet: "Katasterblatt",
    cadastralParcel: "Parzelle",
    cadastralSub: "Unterparzelle",
    cinCode: "CIN-Code",
    maxOccupants: "Maximale Belegung",
    petsAllowed: "Haustiere erlaubt",
    dashboard: "Dashboard",
    contracts: "Vertrage",
    newContract: "Neuer Vertrag",
    noContracts: "Keine Vertrage gefunden",
    createFirst: "Erstellen Sie Ihren ersten Vertrag",
    contractDetails: "Vertragsdetails",
    nights: "Nachte",
    checkIn: "Check-in",
    checkOut: "Check-out",
    totalRent: "Gesamtmiete",
    deposit: "Anzahlung",
    balance: "Restbetrag",
    touristTax: "Kurtaxe",
    paymentMethod: "Zahlungsmethode",
    securityDeposit: "Kaution",
    placeDate: "Ort und Datum",
    guestData: "Gastdaten",
    documentNumber: "Dokument (Art und Nummer)",
    signature: "Unterschrift",
    signContract: "Vertrag unterzeichnen",
    clearSignature: "Unterschrift loschen",
    submitSignature: "Unterschrift bestatigen",
    privacyConsent: 'DATENSCHUTZ & DATEN: Die Plattform "Locazione Turistica" speichert, bewahrt oder verarbeitet keine personenbezogenen Daten, die in diesen Vertrag eingegeben werden. Die Software dient ausschliesslich als technisches Werkzeug zur Echtzeit-Erstellung des Dokuments. Der Verantwortliche fur die Datenverarbeitung ist der Gastgeber, der allein fur die Aufbewahrung und den Schutz der unterzeichneten Daten gemaess der DSGVO verantwortlich ist. Mit der Unterschrift erklaert der Gast seine Zustimmung.',
    privacyAccept: "Ich akzeptiere die Datenschutzrichtlinie",
    pending: "Ausstehend",
    completed: "Abgeschlossen",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Loschen",
    download: "Herunterladen",
    share: "Link teilen",
    copy: "Kopieren",
    copied: "Kopiert!",
    profileSaved: "Profil gespeichert",
    contractCreated: "Vertrag erstellt",
    contractSigned: "Vertrag erfolgreich unterschrieben",
    linkCopied: "Link in die Zwischenablage kopiert",
    landlord: "DER VERMIETER",
    tenant: "DER MIETER (GAST)",
    propertyObject: "MIETOBJEKT",
    stayDuration: "AUFENTHALTSDAUER",
    rentPayment: "MIETE UND ZAHLUNGSMODALITATEN",
    houseRules: "HAUSORDNUNG",
    landlordSignature: "UNTERSCHRIFT DES VERMIETERS",
    tenantSignature: "UNTERSCHRIFT DES MIETERS",
  }
};

export const languageNames = {
  ITA: "Italiano",
  ENG: "English",
  FRA: "Français",
  SPA: "Español",
  TED: "Deutsch"
};

export const languageFlags = {
  ITA: "🇮🇹",
  ENG: "🇬🇧",
  FRA: "🇫🇷",
  SPA: "🇪🇸",
  TED: "🇩🇪"
};
